import React, { useState, useEffect } from "react";
import axios from 'axios';
import Sectiontitle from "../components/Sectiontitle";
import Layout from "../components/Layout";
import Service from "../components/Service";

function About(){
  const [information, setInformation] = useState("");
  const [services, setServices] = useState([]);

  useEffect(() =>{
    axios.get('/api/information')
      .then(response =>{
        setInformation(response.data)
      })
    axios.get('/api/services')
      .then(response =>{
        setServices(response.data)
      })
  }, [])

  return (
    <Layout>
      <div className="mi-about-area mi-section mi-padding-top">
        <div className="container">
          <Sectiontitle title="About Me" />
          <div className="row">
            <div className="col-lg-6">
              <div className="mi-about-image">
                <img
                  src={information.aboutImage}
                  alt="about"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mi-about-content">
                <p>
                  Hi, I'm James — a Cloud Security Engineer based in Louisville, KY. I currently work at Coalfire helping organizations achieve and maintain <strong>FedRAMP compliance</strong> across AWS, GCP, and Azure.
                </p>
                <p style={{marginTop: '15px'}}>
                  I build the infrastructure that keeps cloud environments secure and auditable at scale — from designing IAM architectures and authoring Terraform modules to deploying monitoring, vulnerability management, and configuration tooling.
                </p>
                <p style={{marginTop: '15px'}}>
                  Before moving into cloud security, I worked as a software engineer, which means I can speak both the developer and security language fluently. I have a passion for technology and a drive to keep learning. Feel free to connect via <a href="https://www.linkedin.com/in/james-maddox/">LinkedIn</a>!
                </p>
                <a href={information.cvfile} className="mi-button" target="_blank" rel="noopener noreferrer">Download Resume</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {services.length > 0 && (
        <div className="mi-service-area mi-section mi-padding-top mi-padding-bottom">
          <div className="container">
            <Sectiontitle title="What I Do" />
            <div className="row mt-30-reverse">
              {services.map(service => (
                <div className="col-lg-4 col-md-6 mt-30" key={service.title}>
                  <Service content={service} />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

export default About;
